/** @format */

import React, { memo } from 'react';

import styled from 'styled-components';
import { UIText } from './Text';

export const UILoader = memo(() => (
  <Wrapper>
    <Container>
      <p>
        <UIText text="loading" intlFormatter />
      </p>
      <Loader>
        <span />
      </Loader>
    </Container>
  </Wrapper>
));

export const WrapperLoader = styled.div`
  display: flex;
  justify-content: center;
`;

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  z-index: 2;
  width: 100%;
  height: 100%;
  background: ${({ theme }) => theme.colors.joivy.white};
  display: flex;
  align-items: start;
  justify-content: center;
  padding-top: 130px;
  padding-bottom: 166px;

  @media screen and (min-width: 1160px) {
    padding-top: 227px;
    padding-bottom: 247px;
  }
`;

const Container = styled.div`
  color: ${({ theme }) => theme.colors.joivy.black};
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`;

const Loader = styled.div`
  width: 200px;
  height: 50px;
  position: relative;

  span {
    background-color: $c-01;
    border-radius: 50px;
    display: block;
    height: 1rem;
    width: 1rem;
    bottom: 0;
    position: absolute;
    transform: translateX(64px);
    animation: loading 3.5s ease both infinite;

    &:before {
      position: absolute;
      content: '';
      width: 100%;
      height: 100%;
      background-color: ${({ theme }) => theme.colors.joivy['teal-dark']};
      border-radius: inherit;
      animation: loading2 3.5s ease both infinite;
    }

    @keyframes loading {
      0% {
        width: 16px;
        transform: translateX(0px);
      }
      40% {
        width: 100%;
        transform: translateX(0px);
      }
      80% {
        width: 16px;
        transform: translateX(64px);
      }
      90% {
        width: 100%;
        transform: translateX(0px);
      }
      100% {
        width: 16px;
        transform: translateX(0px);
      }
    }

    @keyframes loading2 {
      0% {
        transform: translateX(0px);
        width: 16px;
      }
      40% {
        transform: translateX(0%);
        width: 80%;
      }
      80% {
        width: 100%;
        transform: translateX(0px);
      }
      90% {
        width: 80%;
        transform: translateX(15px);
      }
      100% {
        transform: translateX(0px);
        width: 16px;
      }
    }
  }
`;
